import { defaultParamsReport } from "./state";

export function resetParamsReport(state) {
    state.paramsReport = defaultParamsReport();
}

export function setRowData(state, data) {
    state.rowData = data;
}

export function setLastKey(state, data) {
    state.lastKey = data;
}

export function setConfigData(state, data) {
    state.configData = data;
}

export function resetRowData(state) {
    state.rowData = [];
}

export function setCurrentRowData(state, data) {
    state.currentRowData = {
        ...state.currentRowData,
        [data.key]: data.data
    };
}



// WEBPACK FOOTER //
// ./src/modules/tax-liquidator/mutations.js